export default (canvasWidth, canvasHeight) => {
	return class Point {
		constructor(x, y) {
			this.x = x / canvasWidth;
			this.y = y / canvasHeight;
		}
	};
};
